function easeInOutQuad(x) {
    return x < 0.5 ? 2 * x * x : 1 - Math.pow((-2 * x + 2), 2) / 2;
}
var easingFns = {
    easeInOutQuad: easeInOutQuad,
};

export { easingFns };
